<template>
  <footer class="footer">
    <i-local-nexon-logo-full class="logo" />
    <div class="footer-group1">
      <div class="copyright">{{ $t('copyright', [currentYear]) }}</div>
      <div v-if="languages && languages.length > 1" ref="select" v-click-outside="close" class="locale">
        <div
          class="current-language"
          tabindex="0"
          @click="toggle()"
          @keydown.esc.stop.prevent="close"
          @keydown.space.stop.prevent="toggle"
          @keydown.enter.stop.prevent="toggle"
        >
          <!--          <country-flag :locale="currentLocale" class="icon-locale" />-->
          <span>{{ $t(`languages.${currentLocale}`) }}</span>
          <!-- <i-bi-globe class="icon-locale" /> -->
        </div>

        <transition name="menu">
          <ul v-show="showLanguage" class="languages list-unstyled">
            <li v-for="locale in languages" :key="locale" ref="refLangMenus" tabindex="0" @click="setLang(locale)">
              <!--              <country-flag :locale="locale" class="icon-locale" />-->
              <span>{{ $t(`languages.${locale}`) }}</span>
            </li>
          </ul>
        </transition>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { SUPPORT_LOCALES } from '@/i18n'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'

const { locale: currentLocale } = useI18n()

const route = useRoute()
const router = useRouter()
const currentYear = new Date().getFullYear()
const showLanguage = ref(false)
const languages = SUPPORT_LOCALES

const refLangMenus = ref<HTMLElement[]>([])

function close() {
  showLanguage.value = false
}
function toggle() {
  showLanguage.value = !showLanguage.value
}
function setLang(locale: string) {
  localStorage.setItem('ial/locale', locale) // store locale only when it's manual setting
  router.replace({ params: { locale, from: location.href }, query: route.query })
  showLanguage.value = false
}
</script>
<style lang="less" scoped>
.footer {
  background-color: #232427; // always dark mode
  color: #747a86; // always dark mode
  // padding: 16px 20px 6px;
  font-size: 12px;
  text-align: center;
  position: fixed; //temp positioning
  bottom: 0;
  width: 100%;
  min-height: 50px;
  display: block;

  .footer-group1 {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0 14px;
  }
  .copyright {
    font-size: 10px;
    padding: 0;
  }
  .locale {
    display: inline-flex;
    align-items: center;
    position: relative;
    vertical-align: top;
    // margin: 2px 5px 10px;

    .current-language {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      padding-left: 10px;
      font-size: 14px;

      &:hover {
        color: #0078ff;
      }
      > span {
        padding: 0 0 4px 10px;
      }
      .icon-locale {
        width: 20px;
        height: 20px;
      }
    }
    span {
      margin-top: 2px;
      vertical-align: top;
      display: inline-block;
    }
  }
  .languages {
    // display: inline-block;
    position: absolute;
    width: auto;
    text-align: left;
    bottom: 26px;
    box-shadow: 3px 3px 15px 3px #000000;
    background-color: #161616;
    li {
      position: relative;
      // line-height: 2em;
      white-space: nowrap;
      display: flex;
      padding: 4px 10px;
      cursor: pointer;
      align-items: center;
      :focus {
        border-width: 2px;
      }

      // transition: all 0.3s;
      > .icon-locale {
        margin: 2px 8px 0 0;
        width: 20px;
        height: 20px;
      }
      &:hover {
        background-color: #0078ff;
        color: white;
      }
    }
  }
}
.logo {
  width: 66px;
  height: 20px;
  margin-top: 20px;
}
@media only screen and (min-width: 480px) {
  .copyright {
    padding: 0 20px 0 0;
  }
}
@media only screen and (min-width: 768px) {
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;

    .logo {
      margin: 0;
    }
    .locale {
      .current-language {
        .icon-locale {
          width: 30px;
          height: 30px;
        }
      }
    }
    .copyright {
      padding: 0 20px 0 18px;
    }
  }
}
.menu-enter-active,
.menu-leave-active {
  transition: opacity 0.2s;
}

.menu-enter-from,
.menu-leave-to {
  opacity: 0;
}
</style>
